/* eslint-disable max-lines-per-function */
import React from 'react'
import { authFetch } from '~/services/fetch'

export async function getHeatMapFiltered(
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  locationAccuracy,
  phone,
  requester,
  userId,
  geographicalArea,
  districtIds,
  startTime?,
  endTime?,
) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatches-by-coordinates',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        operationId: operationId,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        locationAccuracy: locationAccuracy,
        phone: phone,
        geographicAreas: geographicalArea,
        name: requester,
        userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}
